export const ALWAYS_LAST_KEY = '__dataGridSorting__alwaysLast';

export function dataGridSortNumber(firstRow, secondRow, columnName, ascending) {
    if (resolvesToAlwaysLast(firstRow, secondRow)) {
        return alwaysLastResult(firstRow, secondRow, ascending);
    }

    let comparisonResult = (parseFloat(firstRow[columnName]) < parseFloat(secondRow[columnName])) ? 1 : -1;

    if(ascending) {
        comparisonResult *= -1;
    }

    return comparisonResult;
}

export function dataGridSortMoney(firstRow, secondRow, columnName, ascending) {
    if (resolvesToAlwaysLast(firstRow, secondRow)) {
        return alwaysLastResult(firstRow, secondRow, ascending);
    }

    let comparisonResult = (parseInt(firstRow[columnName].amount) < parseInt(secondRow[columnName].amount)) ? 1 : -1;

    if(ascending) {
        comparisonResult *= -1;
    }

    return comparisonResult;
}

export function dataGridSortText(firstRow, secondRow, columnName, ascending) {
    if (resolvesToAlwaysLast(firstRow, secondRow)) {
        return alwaysLastResult(firstRow, secondRow, ascending);
    }

    let comparisonResult = firstRow[columnName].localeCompare(secondRow[columnName]);

    if(ascending) {
        comparisonResult *= -1;
    }

    return comparisonResult;
}

// ALWAYS LAST HANDLERS:
function resolvesToAlwaysLast(firstRow, secondRow) {
    return firstRow[ALWAYS_LAST_KEY] === true || secondRow[ALWAYS_LAST_KEY] === true;
}

function alwaysLastResult(firstRow, secondRow, columnName, ascending) {

    if (firstRow[ALWAYS_LAST_KEY] === true) {
        return ascending ? -1 : 1;
    }
    if (secondRow[ALWAYS_LAST_KEY] === true) {
        return ascending ? 1 : -1;
    }

    return 0;
}
